import { DateTime } from '@ksyos/date-time';

export function isToday(value: Date | string) {
    const today = DateTime.now();
    const date = DateTime.from(value);

    if (!date.isValid()) {
        throw new Error('Invalid date');
    }

    if (!date.isSame(today, 'day')) {
        throw new Error('Only current date is accepted');
    }

    return value;
}
